import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

interface Props {
  lang: 'tr' | 'en';
}

export const LanguageWrapper: React.FC<Props> = ({ lang }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  // Handle hreflang URLs properly
  // If we are on /en/about, the TR equivalent is /about
  // If we are on /hakkimizda, the EN equivalent is /en/about (we assume the current path structure but ideally paths should map)
  // For now we just prepend /en for English, and remove /en for Turkish if we had a mapping. 
  // A simple mapping:
  const isEnglish = location.pathname.startsWith('/en');
  const pathWithoutLang = isEnglish ? location.pathname.substring(3) : location.pathname;
  const safePath = pathWithoutLang === '' ? '/' : pathWithoutLang;

  return (
    <>
      <Helmet>
        <html lang={lang} />
        {/* Hreflang tags for SEO */}
        <link rel="alternate" hreflang="tr" href={`https://patoyazilim.com${safePath}`} />
        <link rel="alternate" hreflang="en" href={`https://patoyazilim.com/en${safePath === '/' ? '' : safePath}`} />
        <link rel="alternate" hreflang="x-default" href={`https://patoyazilim.com${safePath}`} />
      </Helmet>
      <Outlet />
    </>
  );
};
